import {
  AnalyticWidgetItemProps,
  usePeriodLabel
} from '../AnalyticWidgetItem.helpers'
import { highchartOptions, highchartOptionsBar } from './helpers'
import { HighchartsSpider } from 'components/atoms/Highcharts'
import Highcharts from 'highcharts'
import HighchartsHeatMap from 'highcharts/modules/heatmap'
import HighchartsTreeMap from 'highcharts/modules/treemap'
import { FC, useEffect, useMemo, useRef, useState } from 'react'
import { useLocation, useMatch } from 'react-router'
import styled from 'styled-components'

// const data = {
//   count_1_child: 123,
//   count_2_child: 24,
//   count_3_child: 55,
//   count_4_child: 90,
//   count_4_plus_child: 75
// }

const StyledWrap = styled.div`
  .highcharts-title {
    display: none;
  }
`

export const AnalyticWidgetItemBreakdownByNumberOfChildren: FC<
  AnalyticWidgetItemProps
> = (props) => {
  const { data, item } = props
  const location = useLocation()
  const isSegmentDetail = useMatch('/segment/:id')
  console.log('pathname', location.pathname)
  const chartRef = useRef<Highcharts.Chart | null>(null)
  const label = usePeriodLabel(item?.query?.period)
  const [isShow, setIsShow] = useState(false)
  const showBarChart = isSegmentDetail || item?.data?.showBarChart

  useEffect(() => {
    HighchartsHeatMap(Highcharts)
    HighchartsTreeMap(Highcharts)
    setTimeout(() => {
      setIsShow(true)
    }, 300)
  }, [])

  useEffect(() => {
    if (!isShow || showBarChart) return

    const {
      count_1_child = 0,
      count_2_child = 0,
      count_3_child = 0,
      count_4_child = 0,
      count_4_plus_child = 0
    } = data
    const min = Math.min(
      count_1_child,
      count_2_child,
      count_3_child,
      count_4_child,
      count_4_plus_child
    )
    const max = Math.max(
      count_1_child,
      count_2_child,
      count_3_child,
      count_4_child,
      count_4_plus_child
    )

    Highcharts.chart(
      'container-tree-map',
      highchartOptions({
        min,
        max,
        count_1_child,
        count_2_child,
        count_3_child,
        count_4_child,
        count_4_plus_child
      }),
      (chart) => {
        chartRef.current = chart
      }
    )
  }, [data, isShow, showBarChart])

  const optionsBarChart = useMemo(() => {
    const {
      count_1_child = 0,
      count_2_child = 0,
      count_3_child = 0,
      count_4_child = 0,
      count_4_plus_child = 0
    } = data
    return highchartOptionsBar({
      count_1_child,
      count_2_child,
      count_3_child,
      count_4_child,
      count_4_plus_child
    })
  }, [])

  useEffect(() => {
    chartRef.current?.reflow?.()
  }, [props.fullWidth])

  return (
    <div className="flex flex-col h-full">
      <div className="flex items-center justify-between">
        <h4 className="period mb-0 text-gray600">{label}</h4>
      </div>
      <StyledWrap className="flex-1 min-h-0">
        {showBarChart ? (
          isShow && (
            <HighchartsSpider
              options={optionsBarChart as any}
              className="h-full"
              emptyProps={{
                className:
                  'h-full flex-1 min-h-[400px] flex flex-col justify-center',
                iconClassName: 'text-[80px]'
              }}
            />
          )
        ) : (
          <div id="container-tree-map"></div>
        )}
      </StyledWrap>
    </div>
  )
}

export const formatBreakdownByNumberOfChildren = (data: any) => {
  const {
    count_1_child = 0,
    count_2_child = 0,
    count_3_child = 0,
    count_4_child = 0,
    count_4_plus_child = 0
  } = data
  const total =
    count_1_child +
    count_2_child +
    count_3_child +
    count_4_child +
    count_4_plus_child
  return total > 0
}
